import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { usePaymentMethodState } from "./";

export default function AddPaymentMethodSettingsSummaryBar({ currentScreen }) {
  let {
    nickname,
    isSavedPaymentMethod,
    isDefaultPaymentMethod,
    isTextToGiveEnabled,
    isSharedWithHousehold,
    sharableWith = [],
    hasOtherPaymentMethods,
    mustSaveCard,
    isAlreadyExisting,
    hasMobilePhone,
    submitting,
    canSaveCard,
  } = usePaymentMethodState();

  let isPaymentForm = currentScreen === "paymentForm"; // only "Card Saved" should display in payment form

  // Per OB, we are removing the TTG setting option for now so we are always treating it as if they do not have a mobile phone
  hasMobilePhone = false;

  if (!canSaveCard) return null;

  return (
    <Wrapper>
      {!submitting && <Background />}
      <Container
        whileTap={{ scale: submitting ? 1 : 0.97 }}
        $withBorder={isPaymentForm}
      >
        {!mustSaveCard &&
          !isAlreadyExisting &&
          (!hasMobilePhone || sharableWith?.length === 0) && (
            <Setting>
              <Icon className="fas fa-lock" />
              <Text>
                {!isSavedPaymentMethod && "Not "}
                {isPaymentForm ? "Card Saved" : "Saved"}
              </Text>
            </Setting>
          )}
        {isSavedPaymentMethod && !isPaymentForm && (
          <>
            {hasOtherPaymentMethods && (
              <Setting>
                <Icon
                  className={
                    (isDefaultPaymentMethod ? "fas" : "far") + " fa-star"
                  }
                />
                <Text>{!isDefaultPaymentMethod && "Not "}Default</Text>
              </Setting>
            )}
            {hasMobilePhone && !isPaymentForm && (
              <Setting>
                <Icon
                  className={
                    (isTextToGiveEnabled ? "fas" : "far") + " fa-mobile-alt"
                  }
                />
                <Text>Text to Give{!isTextToGiveEnabled && " Off"}</Text>
              </Setting>
            )}
            {sharableWith.length > 0 && !isPaymentForm && (
              <Setting>
                <Icon
                  className={
                    (isSharedWithHousehold ? "fas" : "far") + " fa-user-friends"
                  }
                />
                <Text>{!isSharedWithHousehold && "Not "}Shared</Text>
              </Setting>
            )}
            {!hasOtherPaymentMethods &&
              !hasMobilePhone &&
              sharableWith.length === 0 &&
              !isPaymentForm && (
                <Setting>
                  <Icon
                    className={
                      (nickname.length > 0 ? "fas" : "far") + " fa-tag"
                    }
                  />
                  <Text>{nickname || "Add a nickname"}</Text>
                </Setting>
              )}
          </>
        )}
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
`;

const Container = styled(motion.div)`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #384a5d;
  text-transform: uppercase;
  font-weight: 400;
  padding: 6px 2px;
  cursor: pointer;
  position: relative;
  z-index: 5;
  user-select: none;
  flex-wrap: wrap;

  ${(props) =>
    props.$withBorder
      ? `
    border: 1px solid hsl(211, 25%, 90%); 
    border-radius:  6px;
    `
      : null}
`;

const Background = styled.div`
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s;
  ${Wrapper}:hover & {
    opacity: 0.5;
  }
  ${Wrapper}:active & {
    opacity: 1;
  }
`;

const Setting = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  flex-shrink: 0;
  padding: 0 8px;
`;
const Text = styled.div``;
const Icon = styled.div`
  margin-right: 6px;
`;
